import React from 'react';
export function Page31TrialStrip() {
  return <section className="bg-paper border-y border-subtle-gray py-6" data-id="element-2839">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2840">
        <p className="text-ink leading-relaxed" data-id="element-2841">
          <span className="font-bold text-storm-red uppercase tracking-wide text-sm" data-id="element-2842">
            Trial & Enrollment Info ·
          </span>{' '}
          <span className="text-gray-warm" data-id="element-2843">
            Contact Storm Taekwondo to ask about current trial and enrollment
            options.
          </span>{' '}
          <a href="tel:517-220-0621" className="font-bold text-storm-red hover:underline whitespace-nowrap" data-id="element-2844">
            Call 517-220-0621
          </a>
        </p>
      </div>
    </section>;
}